import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hook/store.hook";
import { selectBusinessUnit } from "../../store/slices/businessUnit.slice";

export const useLoaderBusinessUnit = () => {
  const dispatch = useAppDispatch();
  const { buckets, meta, paginated } = useAppSelector((state) => state.buckets);
  const businessUnitsState = useAppSelector((state) => state.businessUnit);

  const loadBuckets = useCallback((businessUnit: string) => {
    const selected = businessUnitsState.businessUnits.find(
      (bu) => bu.id === businessUnit
    );
    if (selected) {
      dispatch(selectBusinessUnit(selected));
    }
  }, [dispatch, businessUnitsState.businessUnits]);

  return {
    loadBuckets,
    buckets,
    paginated,
    meta,
  };
};
